import { ENDPOINTS } from "../ApiConstants";
import { GET, POST, PUT, DELETE } from "../method";

export const getAirportSearch = async (id) => {
  const url = ENDPOINTS.GET_AIRPORT_SEARCH(id);
  return GET(url);
}

export const getPopularAirportList = async () => {
  const url = ENDPOINTS.POPULAR_AIRPORT_LISTS;
  return GET(url);
}

export const flightSearch = async (data) => {
  const url = ENDPOINTS.FLIGHT_SEARCH;
  return POST(url, data);
}

export const flightReprice = async (data) => {
  const url = ENDPOINTS.FLIGHT_REPRICE;
  return POST(url, data);
}

export const flightBooking = async (data) => {
  const url = ENDPOINTS.FLIGHT_BOOKING;
  return POST(url, data);
}

export const flightCalendarFare = async (data) => {
  const url = ENDPOINTS.FLIGHT_CALENDAR_FARE;
  return POST(url, data);
}

export const getPassenger = async () => {
  const url = ENDPOINTS.GET_PASSENGER;
  return GET(url);
}

export const savePassenger = async (data) => {
  const url = ENDPOINTS.SAVE_PASSENGER;
  return PUT(url, data);
}

export const deletePassenger = async (id) => {
  const url = ENDPOINTS.DELETE_PASSENGER(id);
  return DELETE(url);
}

export const flightBookingHistory = async (id) => {
  const url = ENDPOINTS.FLIGHT_BOOKING_HISTORY(id);
  return GET(url);
}

export const fetchFlightSeatMap = async (data) => {
  const url = ENDPOINTS.SEAT_MAP;
  return POST(url, data);
}

export const fetchFlightMealBaggage = async (data) => {
  const url = ENDPOINTS.MEAL_BAGGAGE;
  return POST(url, data);
}

export const getGSTDetails = async () => {
  const url = ENDPOINTS.GET_GST_DETAIL;
  return GET(url);
}

export const saveGSTDetails = async (data) => {
  const url = ENDPOINTS.SAVE_GST_DETAIL;
  return PUT(url, data);
}

export const flightDetailCards = async (id) => {
  const url = ENDPOINTS.FLIGHT_DETAIL_CARDS(id);
  return GET(url);
};


export const flightAIRecommendation = async (data) => {
  const url = ENDPOINTS.FLIGHT_AI_REECOMMENDATION;
  return POST(url, data);
}